export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (activities, formatTimestamp) {
      


































pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (activities) {
pug_html = pug_html + "\u003Cdiv class=\"refresh\"\u003E\u003Ci class=\"control sync clickable-no-color fa fa-refresh\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"controls\"\u003E\u003Cinput class=\"filter\" placeholder=\"Filter\"\u003E\u003C\u002Fdiv\u003E\u003Ctable class=\"list-activities\"\u003E";
// iterate activities
;(function(){
  var $$obj = activities;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var activity = $$obj[idx];
pug_html = pug_html + "\u003Ctr class=\"activity\"\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = formatTimestamp(activity.timestamp)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = activity.username) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (activity.order_id) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${activity.order_id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = activity.description) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = activity.description) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var activity = $$obj[idx];
pug_html = pug_html + "\u003Ctr class=\"activity\"\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = formatTimestamp(activity.timestamp)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = activity.username) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (activity.order_id) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${activity.order_id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = activity.description) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = activity.description) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "activities" in locals_for_with ?
        locals_for_with.activities :
        typeof activities !== 'undefined' ? activities : undefined, "formatTimestamp" in locals_for_with ?
        locals_for_with.formatTimestamp :
        typeof formatTimestamp !== 'undefined' ? formatTimestamp : undefined));
    ;;return pug_html;}